module.exports = __webpack_public_path__ + "img/arrow-prev-grey-icon.svg";